import { sortBy } from 'lodash';
import React, { useContext, useMemo, useState } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import ModeList from '../components/lists/ModeList';
import { AuthContext } from '../contexts/authContext';
import {
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierModesPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const userHasPermission = useUserPermission();
  const [headerActions, setHeaderActions] = useState(null);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const carrierModes = useMemo(
    () => sortBy(selectedCarrier?.modes, (mode) => mode.defaultModeId),
    [selectedCarrier]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'modePermission');

  const content =
    canView && (
      <>
        <StickyPageHeader
          actions={headerActions}
          subtitle={selectedCarrier.name}
          title="Modes of Transport"
        />
        <ModeList
          carrier={selectedCarrier}
          id="modes"
          modes={carrierModes || []}
          userRole={authUser?.role}
          onHeaderActions={setHeaderActions}
        />
      </>
    );

  if (disableLayout) {
    return content || null;
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierModesPage;
